<template>
	<div class="message-index">
		<common-layout>
			<div slot="header">
				<h3>站内信</h3>
			</div>
			<div slot="container">
				站内信内容
			</div>
		</common-layout>
	</div>
	
</template>

<script>
import CommonLayout from '../../components/common-layout.vue'
export default {
   components: { CommonLayout},
  data() {
    return {};
  },
};
</script>
<style lang="scss">
  @include component(message-index){
	height: 100%;
  }
</style>



